import WorkflowStep from "./workflowStep";
import {WorkflowType} from "~/enums/forms/workflowSteps/workflowType";
import WorkflowStepInterface from "../../../../common/interfaces/workflowStepInterface";
import Validatable from "../../../../common/mixins/validatable";
import AwardStepValidation from "../../../../common/models/navigableValidations/awardStepValidation";
import FormElement from "../formElements/formElement";
export default class AwardStep extends Validatable(WorkflowStep) implements WorkflowStepInterface {
  license_id: string;
  license: {title: string, is_published: boolean};
  license_status_types: any[];
  license_status_client_id: string;
  license_status_activation_type: string;
  activation_on_date_month: number;
  activation_on_date_day: number;
  activation_after_time_interval_amount: number;
  activation_after_time_interval_unit: number;
  activation_relative_date_amount: number;
  activation_relative_date_unit: number;
  activation_relative_date_comparison: number;
  activation_relative_date_event: number;
  activation_formula: string;
  update_license_dates: boolean;
  update_license_dates_type: number;
  update_license_relationship: boolean;
  update_license_relationship_from_field: FormElement;
  update_license_relationship_from_field_client_id: string;
  license_relationship_id: string;
  license_relationship: {relationship_display: string, id: string};

  constructor(form?) {
    super(form);
    this.defineProperty('workflow_type', WorkflowType.licenseStatusChange);
    this.defineProperty('license_id', '');
    this.defineProperty('license_status_activation_type', null);
    this.defineProperty('license_status_client_id', null);
    this.defineProperty('activation_on_date_month', null);
    this.defineProperty('activation_on_date_day', null);
    this.defineProperty('activation_after_time_interval_amount', null);
    this.defineProperty('activation_after_time_interval_unit', null);
    this.defineProperty('activation_relative_date_amount', null);
    this.defineProperty('activation_relative_date_unit', null);
    this.defineProperty('activation_relative_date_comparison', null);
    this.defineProperty('activation_relative_date_event', null);
    this.defineProperty('activation_formula', null);
    this.defineProperty('update_license_dates', null);
    this.defineProperty('update_license_dates_type', null);
    this.defineProperty('license_relationship', null);


  }

  //***** validation ***** //
  _validation: AwardStepValidation = new AwardStepValidation(this);


  get UNTRACKED_PROPERTIES(): string[] {
    return ['license', 'license_status_types', 'license_relationship', 'update_license_relationship_from_field'];
  }

  get titleOrDefault(): string {
    return this.title || `License Status Change`
  }

  public resetStatusActivationConfigs(): void {
    this.activation_on_date_month = null;
    this.activation_on_date_day = null;
    this.activation_after_time_interval_amount = null;
    this.activation_after_time_interval_unit = null;
    this.activation_relative_date_amount = null;
    this.activation_relative_date_unit = null;
    this.activation_relative_date_comparison = null;
    this.activation_relative_date_event = null;
    this.activation_formula = null;
  }

}